export default "__VITE_ASSET__Pstkco_z__"